import {
  VaccineNameModel,
  IVaccineNameModel,
} from '@common/models/VaccineNameModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class VaccineNameService {
  private static baseUrl: string = '/api/vaccinename';

  static tags = {
    vaccineName: 'vaccineName',
  };

  static upsertVaccineName = (
    data: IVaccineNameModel,
    options?: ServiceMethodOptions,
  ): Promise<VaccineNameModel> => {
    return trackPromise(
      new Promise<IVaccineNameModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<IVaccineNameModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess('Vaccine Name updated.', options);
            resolve(new VaccineNameModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to update Vaccine Name.', options);
            reject(err);
          });
      }),
      this.tags.vaccineName,
    );
  };

  static deleteVaccineName = (
    vaccineNameId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${vaccineNameId}`)
          .delete()
          .then(() => {
            ServiceHelper.showSuccess(
              'Vaccine Name has been deleted.',
              options,
            );
            resolve(true);
          })
          .catch((err) => {
            ServiceHelper.showError('Failed to delete Vaccine Name.', options);
            reject(err);
          });
      }),
      this.tags.vaccineName,
    );
  };
}
